import Link from 'next/link';
import Workforce from './workforce';

const Pricing = () => (
  <div id="pricing-self-serve">
    <Workforce />
    <div className="pt-16 text-sm text-gray-500">
      All pricing is for data that does not contain Restricted Information, as defined by{' '}
      <Link href="legal/msa">
        <a className="text-gray-400 ">Scale AI’s Master Software and Services Agreement</a>
      </Link>
      . For projects that contain Restricted Information, or for public sector or government
      projects that require specialized data handling or security, please{' '}
      <Link href="/sales">
        <a className="text-gray-400 ">contact us</a>
      </Link>
      .
    </div>
  </div>
);

export default Pricing;
